import { useState, useContext, useEffect } from 'react';
import { motion } from "framer-motion";
import Footer from '../../includes/footer-tab'; // Adjust path
import Preloader from '../Preloader'; // Adjust path
import BackButton from '../../includes/Back_btn'; // Adjust path
import { AuthContext } from '../../context/AuthContext'; // Adjust path
import styles from '../../assets/css/RateList.module.css'; // Import NEW CSS Module
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { ToastContainer, toast } from 'react-toastify'; // Import Toast
import 'react-toastify/dist/ReactToastify.css';

function RateList() {
    const [preloader, setPreloader] = useState(true);
    // const [Data, setData] = useState(""); // Data state seems unused for description display
    const [jodirate, setJodiRate] = useState("N/A"); // Default value
    const [hurfrate, setHurfrate] = useState("N/A"); // Default value
    const {
        app_name = "AGHORI MATKA", // Default App Name
        GameRule,
        isAuthenticated
    } = useContext(AuthContext);
    const navigate = useNavigate(); // Hook for navigation

    // Redirect if not authenticated
    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated, navigate]);

    // Toast message function
    const message = (status, text) => {
        const options = {
            position: "top-right", autoClose: 3000, hideProgressBar: false,
            closeOnClick: true, pauseOnHover: true, draggable: true,
            progress: undefined, theme: "dark", // Use dark theme
        };
        // Only show error toasts on this page for now
        if (status === 0) toast.error(text, options);
    };


    // Fetch game rules/rates
    useEffect(() => {
        let isMounted = true;
        setPreloader(true);
        if (GameRule) {
            GameRule((response) => {
                if (!isMounted) return;
                setPreloader(false);
                if (response.status === 0) {
                    message(0, response.msg || "Failed to load rates.");
                } else {
                    setJodiRate(response.jodirate || "N/A");
                    setHurfrate(response.hurfrate || "N/A");
                    // setData(response.data?.description || ""); // Set data if you plan to display it
                }
            });
        } else {
            setPreloader(false); // Hide preloader if function not available
            message(0, "Rate function not available.");
        }
        return () => { isMounted = false; }; // Cleanup
    }, [GameRule]); // Dependency

    // Framer Motion variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };
    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100 } },
    };

    return (
        <>
            <Preloader status={preloader} />
            <ToastContainer position="top-right" autoClose={3000} theme="dark" />

            {/* Use the Aghori theme container */}
            <div className={styles.aghoriRateListContainer}>
                {!preloader && (
                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        exit={{ opacity: 0 }}
                    >
                        {/* --- Header --- */}
                        <motion.div className={styles.aghoriHeader} variants={itemVariants}>
                            <BackButton className={styles.backButton} />
                            <p className={styles.headerTitle}>Rate List</p>
                            {/* Optional: Placeholder for right-side icon/link if needed */}
                            <div className={styles.headerPlaceholder}></div>
                        </motion.div>

                        {/* --- Rate Card --- */}
                        <motion.div className={styles.rateCard} variants={itemVariants}>
                            <h2 className={styles.cardTitle}>{app_name} Rate List</h2>
                            <div className={styles.rateItem}>
                                <span className={styles.rateType}>Jodi</span>
                                <span className={styles.rateWin}>
                                    100 <span className={styles.smallText}>KA</span> {jodirate}
                                </span>
                            </div>
                            <div className={styles.rateItem}>
                                <span className={styles.rateType}>Harf</span>
                                <span className={styles.rateWin}>
                                    100 <span className={styles.smallText}>KA</span> {hurfrate}
                                </span>
                            </div>
                            {/* Removed the app mention paragraph to match other pages */}
                        </motion.div>

                        {/* Optional: Add more game rate details here if available */}
                        {/* Example:
                        <motion.div className={styles.rateCard} variants={itemVariants}>
                           <h2 className={styles.cardTitle}>Other Rates</h2>
                           <div className={styles.rateItem}>
                               <span className={styles.rateType}>Single Panna</span>
                               <span className={styles.rateWin}>10 KA 1400</span>
                           </div>
                           <div className={styles.rateItem}>
                               <span className={styles.rateType}>Double Panna</span>
                               <span className={styles.rateWin}>10 KA 2800</span>
                           </div>
                        </motion.div>
                        */}

                    </motion.div>
                )}
            </div>
            {/* --- Footer --- */}
            <Footer /> {/* Ensure Footer component uses the correct CSS */}
        </>
    );
}

export default RateList;
